import { type TranslationTree } from '@/i18n/types';

export const messages = {
  position: 'Local {{n}}',
  remove: 'Remover local',
  optional: 'opcional',
  label: 'Nome do local',
  labelPlaceholder: 'Ex.: Unidade Pinheiros',
  empty: 'Nenhum endereço. Adicione quando a oferta valer em um lugar físico.',
  emptyRequired: 'O botão "Como chegar" precisa de pelo menos um endereço.',
  add: 'Adicionar endereço',
  addAnother: 'Adicionar outro local',
} satisfies TranslationTree;
